import React from "react";
import { TableRow, withStyles } from "@material-ui/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import TagColor from "../../Common/TagColor";
import TableCellStyled from "../../Common/TableCellStyled";

import { displayData } from "../../../utils/data";

import colors from "../../../assets/style/colors";
import { getProfileImage } from "../../../utils/profile";
import Picture from "../../Common/Picture";
import images from "../../../assets/img/images";
import ProfileDialog from "../../Profiles/ProfileDialog";

const styles = {
  cell: {
    height: "50px",
    padding: "0px 8px !important",
    color: colors.black54,
  },
  spanCell: {
    verticalAlign: "top",
    paddingTop: "11px !important",
    borderBottom: `1px solid ${colors.darkGrey}`,
  },
};

const CompanyCountsDialogRow = (props) => {
  const { classes, item, index, language } = props;

  const profileImage = getProfileImage({
    images: get(item, ["images"]),
    type: { id: get(item, ["profile_type_id"]) },
  });

  return (
    <TableRow
      style={{
        backgroundColor: index % 2 === 0 ? colors.white : colors.lightGrey,
      }}
    >
      <TableCellStyled className={classes.cell}>
        <Grid container alignItems="center" wrap="nowrap">
          <Grid
            item
            className="flexCenter"
            style={{
              minWidth: "40px",
              justifyContent: "center",
              height: "40px",
              borderRadius: "4px",
              marginRight: "10px",
              backgroundColor: !profileImage ? colors.mediumGrey : "",
            }}
          >
            {profileImage ? (
              <Picture
                url={profileImage}
                maxHeight={40}
                alt="profile_image"
                style={{
                  maxWidth: "80px",
                  maxHeight: "40px",
                  borderRadius: "4px",
                }}
              />
            ) : (
              <img
                src={
                  get(item, ["profile_type_id"]) === 1
                    ? images.humanIconBlack
                    : get(item, ["profile_type_id"]) === 2
                    ? images.truckIconBlack
                    : get(item, ["profile_type_id"]) === 3
                    ? images.trailerIconBlack
                    : get(item, ["profile_type_id"]) === 4
                    ? images.containerIconBlack
                    : null
                }
                style={{ maxWidth: "30px", maxHeight: "25px" }}
                alt="profile_icon"
              />
            )}
          </Grid>
          <Grid item>
            <ProfileDialog
              profileId={get(item, ["profile_id"])}
              name={
                get(item, ["profile_name"]) ||
                `${get(item, ["profile_firstname"])} ${get(item, [
                  "profile_lastname",
                ])}`
              }
              blockLevel2={true}
              onClose={() => props.refresh()}
            />
          </Grid>
        </Grid>
      </TableCellStyled>
      <TableCellStyled className={classes.cell}>
        {get(item, [`profile_type_name_${language}`])}
      </TableCellStyled>
      <TableCellStyled className={classes.cell}>
        {displayData(get(item, [`profile_carrier_name_${language}`]))}
      </TableCellStyled>
      <TableCellStyled className={classes.cell}>
        <TagColor
          color={get(item, ["tag_color_code"])}
          name={get(item, [`tag_name_${language}`])}
        />
      </TableCellStyled>
      <TableCellStyled className={classes.cell}>
        {get(item, ["site_name"])}
      </TableCellStyled>
      <TableCellStyled className={classes.cell}>
        {get(item, ["zone_name"])}
      </TableCellStyled>
      <TableCellStyled className={classes.cell}>
        {`${get(item, ["assigned_site_name"])||" - "} / ${get(item, ["assigned_zone_name"])||" - "}`}
      </TableCellStyled>
    </TableRow>
  );
};

export default withStyles(styles)(CompanyCountsDialogRow);
